import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Sprout, Heart, Gift, EyeOff, Eye, Calendar, Radio, HeartHandshake, Smartphone } from "lucide-react";
import api from "@/lib/api";
import { useFeature } from "@/contexts/FeaturesContext";

/* ── Portofelul de Semințe (17.12) ── */


/* ── Modul discret (17.16): acoperă instant tot, dacă intră cineva în cameră ── */
export function DiscreetToggle() {
  const enabled = useFeature("discreet_mode");
  const [covered, setCovered] = useState(false);
  // Comandă rapidă: Esc acoperă imediat
  useEffect(() => {
    const onKey = (e) => { if (e.key === "Escape") setCovered(true); };
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, []);
  if (!enabled) return null;
  return (
    <>
      <button type="button" onClick={() => setCovered(true)} data-testid="discreet-toggle"
        className="fixed bottom-5 left-5 z-40 w-11 h-11 rounded-full flex items-center justify-center shadow-lg"
        style={{ background: "var(--ct-surface)", color: "var(--ct-text-muted)", border: "1px solid var(--ct-border)" }}
        title="Mod discret: acoperă instant tot (sau apasă Esc). Pentru intimitate.">
        <EyeOff size={18} />
      </button>
      {covered && (
        <div className="fixed inset-0 z-[100] flex flex-col items-center justify-center cursor-pointer select-none"
          style={{ background: "var(--ct-bg)" }} onClick={() => setCovered(false)} data-testid="discreet-cover">
          <Eye size={26} style={{ color: "var(--ct-text-dim)" }} className="mb-3" />
          <p className="text-sm" style={{ color: "var(--ct-text-dim)" }}>Atinge oriunde ca să continui</p>
        </div>
      )}
    </>
  );
}
